// File: packages/components/src/agent/AgentHeader.tsx (Updated)

import React from 'react';
import { EditableText } from '@dopomogai/ui'; // Import the new component
import { usePersonalization } from '@dopomogai/agent-kit';

/**
 * A component for displaying the agent's core identity in the builder.
 * It is now fully personalized and editable, powered by the PersonalizationProvider
 * and the new EditableText component.
 */
export function AgentHeader() {
  const { state, dispatch } = usePersonalization();

  return (
    <header className="space-y-2">
      <EditableText
        as="h1" // Render as an H1 for semantic correctness
        value={state.heroTitle || ''}
        onChange={(newValue) => {
          dispatch({ type: 'SET_HERO_TITLE', payload: newValue });
        }}
        placeholder="Click to edit agent title"
        ariaLabel="Agent Title"
        // Pass heading styles to both display and edit modes
        className="text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight"
      />
      <EditableText
        as="p" // Render as a paragraph
        multiline // Enable multi-line editing for the subtitle
        value={state.heroSubtitle || ''}
        onChange={(newValue) => {
          dispatch({ type: 'SET_HERO_SUBTITLE', payload: newValue });
        }}
        placeholder="Click to edit agent subtitle or tagline"
        ariaLabel="Agent Subtitle"
        // Pass subheading styles
        className="text-lg text-slate-600"
      />
    </header>
  );
}